import http from "../http-common";

class DashboardService {
  // Get dashboard statistics
  getStats() {
    return http.get('/dashboard/stats');
  }
}

export default new DashboardService();
